import React from "react";

import { graphql } from "gatsby";

import Button from "cms/components/Button";
import MediaQuery from "cms/components/MediaQuery";
import RichText from "cms/components/RichText";
import Text from "cms/components/Text";
import ComparisonHeadline from "cms/images/comparison-headline-image-improved.png";
import CollabImageDesktopBottom from "cms/images/landing-collab-bottom-image-a.png";
import CollabImageMobileBottom from "cms/images/landing-collab-bottom-image-b.png";
import CollabImageDesktopTop from "cms/images/landing-collab-top-image-a.png";
import CollabImageMobileTop from "cms/images/landing-collab-top-image-b.png";
import BackgroundImageDesktop from "cms/images/landing-image-a.png";
import BackgroundImageMobile from "cms/images/landing-image-b.png";

import {
  BottomBlock,
  BottomBlockIllustration,
  BottomBlockIllustrationContainer,
  ComparisonIllustration,
  ComparisonIllustrationContainer,
  Container,
  Content,
  Gradient,
  HeadlineContainer,
  Illustration,
  IllustrationContainer,
  Link,
  Message,
  Pitch,
  TopBlock,
} from "./UizardVsDesignFuglyBlock.styles";

export interface UizardVsDesignFuglyBlockProps
  extends Queries.SanityUizardVsDesignFuglyBlock {}

const UizardVsDesignFuglyBlock: React.FC<UizardVsDesignFuglyBlockProps> = ({
  headline,
  button,
  _rawPitch,
}) => (
  <Container>
    <Content>
      <TopBlock>
        <Message>
          <ComparisonIllustrationContainer>
            <ComparisonIllustration
              src={ComparisonHeadline}
              alt="Probably the easiest design tool you'll ever use"
            />
          </ComparisonIllustrationContainer>

          <Pitch>
            <RichText text={_rawPitch} />
          </Pitch>

          {button?.url && button?.label && (
            <Link href={button.url}>
              <Button label={button.label} variant="primary" />
            </Link>
          )}
        </Message>

        <MediaQuery $lessThan="medium" style={{ width: "100%" }}>
          <IllustrationContainer>
            <Illustration
              src={BackgroundImageMobile}
              alt="Screenshot of the Uizard's design tool"
            />
          </IllustrationContainer>

          <Gradient />
        </MediaQuery>

        <MediaQuery $greaterThan="medium" style={{ width: "100%" }}>
          <IllustrationContainer>
            <Illustration
              src={BackgroundImageDesktop}
              alt="Screenshot of the Uizard's design tool"
            />
          </IllustrationContainer>

          <Gradient />
        </MediaQuery>
      </TopBlock>

      <BottomBlock>
        <MediaQuery $lessThan="large" style={{ width: "100%" }}>
          <BottomBlockIllustrationContainer>
            <BottomBlockIllustration
              src={CollabImageMobileTop}
              alt="Image of people's cursors collaborating in Uizard: Developer, Business Analyst, CEO"
            />
          </BottomBlockIllustrationContainer>
        </MediaQuery>

        <MediaQuery $greaterThan="large" style={{ width: "100%" }}>
          <BottomBlockIllustrationContainer>
            <BottomBlockIllustration
              src={CollabImageDesktopTop}
              alt="Image of people's cursors collaborating in Uizard: Freelancer, Marketing Manager, Project Manager"
            />
          </BottomBlockIllustrationContainer>
        </MediaQuery>

        <HeadlineContainer>
          <Text variant="H2" as="h2">
            {headline}
          </Text>
        </HeadlineContainer>

        <MediaQuery $lessThan="large" style={{ width: "100%" }}>
          <BottomBlockIllustrationContainer>
            <BottomBlockIllustration
              src={CollabImageMobileBottom}
              alt="Image of people's cursors collaborating in Uizard: Developer, Business Analyst, CEO"
            />
          </BottomBlockIllustrationContainer>
        </MediaQuery>

        <MediaQuery $greaterThan="large" style={{ width: "100%" }}>
          <BottomBlockIllustrationContainer>
            <BottomBlockIllustration
              src={CollabImageDesktopBottom}
              alt="Image of people's cursors collaborating in Uizard: Freelancer, Marketing Manager, Project Manager"
            />
          </BottomBlockIllustrationContainer>
        </MediaQuery>
      </BottomBlock>
    </Content>
  </Container>
);

export const query = graphql`
  fragment UizardVsDesignFuglyBlock on SanityUizardVsDesignFuglyBlock {
    _key
    _type
    headline
    button {
      variant
      label
      url
    }
    _rawPitch(resolveReferences: { maxDepth: 5})
  }
`;

export default UizardVsDesignFuglyBlock;
